import React, { useState } from "react";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import SideBar from "./components/SideBar";
import logo from "../assets/01pos.webp";
import { Outlet } from "react-router";
import { useNavigate } from "react-router";
import ConfirmModal from "../components/ConfirmModal";
import Chat from "./components/Chat";

function Dashboard() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleQuit = () => {
    setIsModalOpen(true); // Open the confirmation modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const navigate = new useNavigate();
  const handleConfirmQuit = () => {
    sessionStorage.clear();
    navigate("/login");
  };
  return (
    <div className="h-screen lg:overflow-y-hidden ">
      <ConfirmModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmQuit}
        text1="Confirm Quit"
        text2="Are you sure you want to quit the app?"
      />
      {/* Header */}
      <div className="h-16 bg-white flex justify-between items-center px-8">
        <img src={logo} alt="logo" className="w-24" />
        <div className="flex gap-4">
          <Chat />
          <button className="">
            <ExitToAppIcon
              onClick={handleQuit}
              className="text-red-500 "
              sx={{ fontSize: 40 }}
            />
          </button>
        </div>
      </div>
      <div className="flex w-full  h-screen flex-col lg:flex-row ">
        <SideBar />
        {/* right bar */}
        <div className="lg:w-10/12 bg-gray-100 h-full px-8 pt-8 pb-24 overflow-x-auto overflow-y-visible lg:overflow-y-scroll">
          {/* COmpany total information */}
          <Outlet />
          {/* Other data */}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
